import { Card, Col, Row } from 'antd';
import React from 'react';

const Contact = () => {
    return (
        <Card title="संपर्क">
            <Row>
                <Col xl={8} lg={8} md={12} sm={24} xs={24}>
                    <h2>
                        गट विकास अधिकारी<br />
                        पंचायत समिती, कागल<br />
                        फोन नं : 02325-244022<br />
                        ई - मेल : bdokagal123@gmail.com</h2>
                </Col>
                <Col xl={16} lg={16} md={12} sm={24} xs={24}>
                    <div style={{ paddingTop: 25 }} dangerouslySetInnerHTML={{ __html: `<div style="text-decoration:none; overflow:hidden;max-width:100%;width:100%;height:500px;"><div id="embed-ded-map-canvas" style="height:100%; width:100%;max-width:100%;"><iframe style="height:100%;width:100%;border:0;" frameborder="0" src="https://www.google.com/maps/embed/v1/place?q=पंचायत+समिटी+कागल,+H8P4+QWC,+Service+Rd,+कागल,+महाराष्ट्र+416216&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"></iframe></div><a class="the-googlemap-enabler" href="https://www.bootstrapskins.com/themes" id="authorize-map-data">premium bootstrap themes</a><style>#embed-ded-map-canvas img{max-height:none;max-width:none!important;background:none!important;}</style></div>` }}>

                    </div>
                </Col>
            </Row>
        </Card>
    );
}

export default Contact;